// extracted by mini-css-extract-plugin
module.exports = {"table":"MagicSquare_table__3I7JQ","time":"MagicSquare_time__1mhE_"};